import PropTypes from 'prop-types';
import { Card, Row, Col, ListGroup, ListGroupItem } from 'react-bootstrap';
import React from 'react';
import Tippy from '@tippyjs/react';
import { MemberRole } from '../team';
import Avatar from '../Avatar.jsx';

const TeamList = ({ memberList }) => (
  <Card>
    <Card.Body>
      <ListGroup variant="flush" className=" my-n3">
        {memberList.map((member, i) => (
          <ListGroupItem key={i}>
            <>
              <Row className="align-items-center">
                <Col md="auto">
                  <div className="avatar">
                    <Avatar
                      firstName={member.firstName}
                      lastName={member.lastName}
                      imgPath={member.avatar ? member.avatar : ''}
                    />
                  </div>
                </Col>
                <Col className="col-5 ml-n2">
                  <h4 className="mb-1">
                    <>
                      {member.firstName} {member.lastName} {}
                      <Tippy
                        content={
                          <>
                            <div className=" dropdown-menu-right">
                              <div className="d-flex flex-column bd-highlight">
                                <div className="p-2 bd-highlight m-1">
                                  Email{' '}
                                  <span className="p-3"> {member.email}</span>
                                </div>
                                {member.phone && (
                                  <div className="p-2 bd-highlight m-1">
                                    Phone Number
                                    <span className="p-3"> {member.phone}</span>
                                  </div>
                                )}
                              </div>
                            </div>
                          </>
                        }
                        theme="light"
                      >
                        <i className="mdi mdi-information-outline text-muted" />
                      </Tippy>
                    </>
                  </h4>
                </Col>
                <Col className="col-auto ms-auto me-n3">
                  <MemberRole role={member.role} />
                </Col>
              </Row>
            </>
          </ListGroupItem>
        ))}
      </ListGroup>
    </Card.Body>
  </Card>
);
TeamList.propTypes = {
  memberList: PropTypes.any,
};

export default TeamList;
